<template>
	<div>
		<div class="header" :class="{'header-fixed': scroll, 'header-transparent dark': transparent,'header-light head-shadow': !transparent}">
			<div class="container">
				<nav
					id="navigation"
					:class="windowWidth > 991 ? 'navigation navigation-landscape' : 'navigation navigation-portrait'"
				>
					<div class="nav-header">
						<router-link to="" class="nav-brand text-logo" >
							<span class="svg-icon text-primary svg-icon-2hx">
								<img :src="logoLight" alt="logo-light">
							</span>
						</router-link>
						<div class="nav-toggle" :style="{ 
							left: $i18n.locale === 'ar' ? '0' : 'auto',
							right: $i18n.locale === 'ar' ? 'auto' : '0'
						}" @click="toggle = !toggle"></div>
						<div class="mobile_nav">
						</div>
					</div>
					<div class="nav-menus-wrapper nav-menus-wrapper-open" :class="{ 'nav-menus-wrapper-open': toggle}"  :style="{
						'left': toggle ? ($i18n.locale === 'ar' ? 'auto' : '0%') : ($i18n.locale === 'ar' ? '100%' : '-100%'),
						'right': $i18n.locale === 'ar' ? (toggle ? '0%' : '-100%') : 'auto'
						}">
						<span class="nav-menus-wrapper-close-button" @click="toggle = !toggle">✕</span>
						<ul class="nav-menu">
							<li><router-link :to="`/${locale}`" class="d-flex align-items-center">{{ $t('Home') }}</router-link></li>
							<li ><router-link :to="`/${locale}/exhibits`" class="d-flex align-items-center">{{ $t('Exhibit') }}</router-link>
							</li>
							<li>
								<router-link :to="`/${locale}/prev-exhibits`" class="d-flex align-items-center">{{ $t('Previous Exhibits') }}</router-link>
							</li>
							<li
								class="has-submenu"
								@mouseenter="isDesktop && (servicesOpen = true)"
								@mouseleave="isDesktop && (servicesOpen = false)"
							>
								<a
								href="javascript:void(0)"
								@click.prevent="!isDesktop && (servicesOpen = !servicesOpen)"
								>
								{{ $t('Services') }}
								</a>

								<!-- Categories -->
								<ul
								class="submenu"
								v-show="servicesOpen"
								:class="locale === 'ar' ? 'submenu-rtl' : 'submenu-ltr'"
								>
								<li
									v-for="cat in categories"
									:key="cat.id"
									class="has-submenu"
									@mouseenter="isDesktop && openCategory(cat.slug)"
								>
									<a
									href="javascript:void(0)"
									@click.prevent="!isDesktop && openCategory(cat.slug)"
									>
									{{ cat.name }}
									</a>

									<!-- Services -->
									<ul
									class="submenu sub-submenu"
									v-show="activeCategory === cat.slug"
									>
									<li
										v-for="srv in servicesByCategory[cat.slug] || []"
										:key="srv.id"
									>
										<router-link :to="`/${locale}/service/${srv.slug}`">
										{{ srv.name }}
										</router-link>
									</li>
									</ul>
								</li>
								</ul>
							</li>
							<li><router-link :to="`/${locale}/about-us`" class="d-flex align-items-center">{{ $t('About') }}</router-link>
							</li>
							<li><router-link :to="`/${locale}/companies`" class="d-flex align-items-center">{{ $t('Companies') }}</router-link>
							</li>
							<li><router-link :to="`/${locale}/contact`" class="d-flex align-items-center">{{ $t('ContactUs') }}</router-link>
							</li>
							<li class="locale-changer">
								<div class="custom-dropdown" @click="toggleDropdown = !toggleDropdown" ref="dropdownRef">
								<div class="selected">
									<img :src="selectedFlag" alt="flag" />
									<span class="lang-name">{{ locale === 'ar' ? 'Arabic' : 'English' }}</span>
								</div>
								<ul v-if="toggleDropdown" class="dropdown-list">
									<li v-for="(locale, index) in availableLocales" :key="index" @click="changeLocale(locale)" class="dropdown-item">
									<div class="flag-container">
										<img :src="getFlag(locale)" alt="flag" class="flag-circle" />
										<span class="lang-name">{{ locale === 'ar' ? 'Arabic' : 'English' }}</span>
									</div>
									</li>
								</ul>
								</div>
							</li>
						</ul>
					</div>
				</nav>
			</div>
		</div>

		<div class="clearfix"></div>
	</div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, computed ,watch} from 'vue';
import enflag from '@/assets/img/svg/en.png';
import arflag from '@/assets/img/svg/ar.png';
import logoLight from '@/assets/img/svg/logo1.webp';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

import axios from 'axios'
const toggle = ref(false);
const windowWidth = ref(window.innerWidth);
const scroll = ref(false);
const toggleDropdown = ref(false);
const availableLocales = ['en', 'ar'];
const selectedFlag = ref('');
const dropdownRef = ref(null);
const handleResize = () => {
windowWidth.value = window.innerWidth;
};

const handleScroll = () => {
scroll.value = window.scrollY >= 50;
};

onMounted(() => {
window.scrollTo(0, 0);
window.addEventListener('resize', handleResize);
window.addEventListener('scroll', handleScroll);

const { locale } = useI18n();
selectedFlag.value = getFlag(locale.value);
document.addEventListener('click', closeDropdownOnClickOutside);
});

onBeforeUnmount(() => {
document.removeEventListener('click', closeDropdownOnClickOutside);
});

const { locale } = useI18n();
const router = useRouter()

const changeLocale = (localeValue) => {
locale.value = localeValue
localStorage.setItem('locale', localeValue)

selectedFlag.value = getFlag(localeValue)
toggleDropdown.value = false
const direction = localeValue === 'ar' ? 'rtl' : 'ltr';
document.documentElement.setAttribute('dir', direction);

const currentRoute = router.currentRoute.value
const newPath = currentRoute.fullPath.replace(
	`/${currentRoute.params.lang}`,
	`/${localeValue}`
)

router.push(newPath)
}

const closeDropdownOnClickOutside = (event) => {
if (dropdownRef.value && !dropdownRef.value.contains(event.target)) {
	toggleDropdown.value = false;
}
};

const getFlag = (locale) => {
return locale === 'ar' ? arflag : enflag;
};	
/* SERVICES */
const isDesktop = computed(() => windowWidth.value > 991)

const servicesOpen = ref(false)
const activeCategory = ref(null)

const categories = ref([])
const servicesByCategory = ref({})

/* Fetch categories */
const fetchCategories = async () => {
try {
	const { data } = await axios.get('/services/categories', {
	params: { lang: locale.value }
	})
	categories.value = data
} catch (e) {
	console.error(e)
}
}

/* Fetch services for category */
const openCategory = async (slug) => {
activeCategory.value = slug

if (servicesByCategory.value[slug]) return

try {
	const { data } = await axios.get(`/services/category/${slug}`, {
	params: { lang: locale.value }
	})
	servicesByCategory.value[slug] = data.services || data
} catch (e) {
	console.error(e)
}
}

onMounted(() => {
window.addEventListener('resize', handleResize)
window.addEventListener('scroll', handleScroll)
fetchCategories()
})

onBeforeUnmount(() => {
window.removeEventListener('resize', handleResize)
window.removeEventListener('scroll', handleScroll)
})

watch(locale, () => {
categories.value = []
servicesByCategory.value = {}
activeCategory.value = null
fetchCategories()
})
</script>
<style scoped>
.locale-changer {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 15px;
  margin-top: 1%;
}

.custom-dropdown {
  position: relative;
  cursor: pointer;
}

.selected {
  display: flex;
  align-items: center;
  padding: 5px 10px;
}

.selected img {
  width: 68px;
  height: 35px;
  margin-right: 10px;
}

.dropdown-list {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  list-style: none;
  padding: 0;
  margin: 0;
  z-index: 10;
  max-height: 200px;
  overflow-y: auto;
}

.dropdown-item {
  display: flex;
  align-items: center;
  padding: 10px;
  /* transition: background-color 0.3s ease; */
  background-color: white;
}

.dropdown-item:hover {
  cursor: pointer;
  background-color: #f1f1f1;
}

/* Style for flag container */
.flag-container {
  display: flex;
  align-items: center;
}

.flag-circle {
  width: 30px;
  height: 30px;
  /* border-radius: 50%; */
  margin-right: 10px;
}
.flag-container .lang-name{
  font-size: 14px;
  color:#2c3f56;
}
.lang-name {
  font-size: 14px;
  color: white;
  margin-inline-start: 6px;
}

.selected {
  display: flex;
  align-items: center;
  padding: 5px 10px;
}

.selected img {
  width: 30px;
  height: 30px;
  /* border-radius: 50%; */
  margin-right: 10px;
}
/*SERVICES DROPDOWN*/
.submenu {
  position: absolute;
  top: 100%;
  min-width: 260px;
  background: #ffffff;
  border-radius: 12px;
  padding: 10px 0;
  box-shadow: 0 10px 35px rgba(0, 0, 0, 0.12);
  opacity: 0;
  transform: translateY(10px);
  pointer-events: none;
  transition: all 0.25s ease;
  z-index: 999;
}

.has-submenu:hover > .submenu,
.submenu[style*="display: block"] {
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
}

.submenu-ltr {
  left: 0;
}
.submenu-rtl {
  right: 0;
}

/*CATEGORY ITEM*/
.submenu > li {
  position: relative;
}

.submenu > li > a {
  display: flex;
  justify-content: space-between;
  padding: 10px 18px;
  font-size: 14px;
  font-weight: 500;
  color: #2c3f56;
  transition: background 0.2s ease;
}

.submenu > li > a:hover {
  background: #f5f7fa;
  color: #C48B6E;
}

/*HEADER / NAV BASE*/

.nav-menu > li {
  position: relative;
}

/*SERVICES DROPDOWN (LEVEL 1)*/

.submenu {
  position: absolute;
  top: 100%;
  margin-top: 2px;
  min-width: 260px;
  background: #ffffff;
  border-radius: 10px;
  padding: 8px 0;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.12);
  opacity: 0;
  transform: translateY(6px);
  pointer-events: none;
  transition: opacity 0.2s ease, transform 0.2s ease;
  z-index: 999;
}

/* show categories */
.has-submenu:hover > .submenu,
.submenu[style*="display: block"] {
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
}

/* LTR / RTL */
.submenu-ltr {
  left: 0;
}
.submenu-rtl {
  right: 0;
}

/*CATEGORY ITEM*/

.submenu > li {
  position: relative;
}

.submenu > li > a {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 18px;
  font-size: 14px;
  font-weight: 500;
  color: #2c3f56;
  white-space: nowrap;
  transition: background 0.15s ease, color 0.15s ease;
}

.submenu > li > a:hover {
  background: #f5f7fa;
  color: #C48B6E;
}

/*SERVICES DROPDOWN (LEVEL 2)*/

.sub-submenu {
  position: absolute;
  top: 0;
  min-width: 260px;
  background: #ffffff;
  border-radius: 10px;
  padding: 8px 0;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.12);
  opacity: 0;
  transform: translateX(6px);
  pointer-events: none;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

/* position */
.submenu-ltr .sub-submenu {
  left: 100%;
}

.submenu-rtl .sub-submenu {
  right: 100%;
  transform: translateX(-6px);
}

/* show services */
.has-submenu:hover > .sub-submenu,
.sub-submenu[style*="display: block"] {
  opacity: 1;
  transform: translateX(0);
  pointer-events: auto;
}

/* service item */
.sub-submenu li a {
  display: block;
  padding: 9px 18px;
  font-size: 13px;
  color: #4a5568;
  white-space: nowrap;
  transition: background 0.15s ease, color 0.15s ease;
}

.sub-submenu li a:hover {
  background: #eef3ff;
  color: #C48B6E;
}
.has-submenu > a::after {
  content: none !important;
}
@media (max-width: 991px) {
  .submenu,
  .sub-submenu {
    position: static;
    min-width: 100%;
    box-shadow: none;
    border-radius: 0;
    transform: none;
    opacity: 1;
    pointer-events: auto;
    margin-top: 0;
  }

  .submenu > li > a {
    padding-left: 20px;
  }

  .sub-submenu li a {
    padding-left: 35px;
  }
}
</style>
